module.exports = __webpack_public_path__ + "static/media/sugar-free.5ae1ddfa.png";